import { Component, OnInit, Inject, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

interface PromotionType {
  title: string;
  description: string;
  value: string;
}

@Component({
  selector: 'app-promotion-type',
  templateUrl: './promotion-type.component.html',
  styleUrls: ['./promotion-type.component.scss']
})
export class PromotionTypeComponent implements OnInit {

  selectedType: string | null = null;
  promotionOption: string | null = null;
  onTypeSelected: (type: string) => void = () => {};

  promotionTypes: PromotionType[] = [
    { 
      title: 'BTG Promotion', 
      description: 'Promotion includes phase 1 & phase 2',
      value: 'BTG Promotion'
    },
    { 
      title: 'PP Promotion', 
      description: 'Promotion includes phase 1 & phase 2',
      value: 'PP Promotion'
    },
    { 
      title: 'Free Spin', 
      description: 'Free spins awarded to users',
      value: 'Free Spin'
    }
  ];

  constructor(
    @Inject('selectedType') selectedType: string | null,
    @Inject('onTypeSelected') onTypeSelected: (type: string) => void,
    @Optional() @Inject('isEditMode') public isEditMode: boolean,
    @Inject('promotionOption') promotionOption: string | null,
    @Inject('freeSpinGameProviderId') freeSpinGameProviderId: string | null,
    private route: ActivatedRoute,
  ) {
    this.selectedType = selectedType;
    this.promotionOption = promotionOption;
    this.onTypeSelected = onTypeSelected;
  }

  ngOnInit(): void {
    if (!this.selectedType && this.promotionTypes.length > 0) {
      this.route.queryParams.subscribe(params => {
        const promoType = params['type'];
        const firstType = (() => {
          if (promoType === 'btg') return this.promotionTypes[0].value;
          if (promoType === 'pp') return this.promotionTypes[1].value;
          if (promoType === 'free-spin') return this.promotionTypes[2].value;
          return this.promotionTypes[2].value;
        })();
        this.selectedType = firstType;
        this.onTypeSelected(firstType);
      });
    }
  }

  onSelect(typeValue: string): void {
    this.selectedType = typeValue;
    this.onTypeSelected(typeValue);
  }
}